import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { CampaignService } from '@app/shared/services';
import { UIDropdownComponent } from '@bannerflow/ui';
import { ICampaignPublishInfo } from '@studio/domain/campaign';
import { hasActiveDesigns } from '@studio/utils/design.utils';
import { Subject, takeUntil } from 'rxjs';
import { CreativesetDataService } from '../../../shared/creativeset';
import { SocialPlacementsService } from '../services';

@Component({
    selector: 'campaigns-dropdown',
    templateUrl: './campaigns-dropdown.component.html',
    styleUrls: ['./campaigns-dropdown.component.scss']
})
export class CampaignsDropdownComponent implements OnDestroy {
    @Input() hasConnectedCampaigns: boolean;
    @Input() isAddToCampaignVisible = true;
    @ViewChild('menu', { static: true }) dropdown: UIDropdownComponent;
    campaigns: ICampaignPublishInfo[] = [];
    addToCampaignDisabled: boolean;
    addToCampaignText: string;
    isSocialCamapaignAvailable: boolean;
    hasActiveDesigns: boolean;
    private unsubscribe$ = new Subject<void>();
    constructor(
        private socialPlacementsService: SocialPlacementsService,
        private campaignService: CampaignService,
        private creativesetData: CreativesetDataService
    ) {
        this.hasActiveDesigns = hasActiveDesigns(this.creativesetData.creativeset.creatives);

        this.socialPlacementsService.isSocialCampaignAvailable$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(isSocialCamapaignAvailable => {
                this.isSocialCamapaignAvailable = isSocialCamapaignAvailable;
            });
    }

    open(): void {
        this.campaigns = this.campaignService.getCampaigns();
    }

    redirectToCreateCampaign(): void {
        this.campaignService.redirectToCreateCampaign();
    }

    redirectToCreateSocialCampaign(): void {
        this.campaignService.redirectToCreateSocialCampaign();
    }

    openCampaign(id: string): void {
        this.campaignService.openCampaign(id);
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
